module.exports = __webpack_public_path__ + "static/media/p1-event-mask-away-desktop.def308c2.png";